<template>
  <enfold>
    <div class="device-detail-open flex-d-b-c">
      <div class="top">
        <img src="@/assets/images/public/public_closearrow.png" @click="close" style="cursor: pointer;" />
        <div class="name">{{ currentDetail.name }}</div>
      </div>
      <div class="title">
        <div class="button">
          <div class="deta" :class="{ detailActive: isDetail == 'detail' }" @click="changeDetail('detail')">
            {{ $t('terminal.deviceDetail') }}</div>
          <div class="playlisty" :class="{ detailActive: isDetail == 'list' }" @click="changeDetail('list')">
            {{ $t('terminal.playList') }}</div>
          <div class="power" :class="{ detailActive: isDetail == 'power' }" @click="changeDetail('power')">
            {{ $t('terminal.power') }}</div>
          <div class="schedule" :class="{ detailActive: isDetail == 'schedule' }" @click="changeDetail('schedule')">
            {{ $t('terminal.timeOrder') }}</div>
          <div class="capture-list" :class="{ detailActive: isDetail == 'captureList' }"
            @click="changeDetail('captureList')">{{ $t('ctcddo1') }}</div>
          <!-- <div class="live" :class="{ detailActive: isDetail == 'live' }" @click="changeDetail('live')">{{$t('terminal.live')}}</div>
          <div class="camera" :class="{ detailActive: isDetail == 'camera' }" @click="changeDetail('camera')">{{$t('terminal.camera')}}</div> -->
          <div class="CentralControl" :class="{ detailActive: isDetail == 'CentralControl' }"
            @click="changeDetail('CentralControl')">{{ $t('terminal.CentralControl') }}</div>
          <div class="PanelMonitoring" :class="{ detailActive: isDetail == 'PanelMonitoring' }"
            @click="changeDetail('PanelMonitoring')">{{ $t('ctcddo2') }}</div>
          <!-- <div class="DeviceGps" :class="{ detailActive: isDetail == 'DeviceGps' }" @click="changeDetail('DeviceGps')">
            {{ $t('ntcd01') }}</div> -->
          <div class="DeviceGps" :class="{ detailActive: isDetail == 'DevicePointList' }"
            @click="changeDetail('DevicePointList')" v-if="!(CPT === 'false')">
            {{ $t('rifp') }}</div>
          <div class="OtherSettings" :class="{ detailActive: isDetail == 'OtherSettings' }"
            @click="changeDetail('OtherSettings')">{{ $t('ctcddo3') }}</div>
        </div>
      </div>
      <template v-if="isDetail == 'detail'">
        <div class="contents">
          <div class="opendetail">
            <div class="open_left">
              <div class="information">
                <div class="b_border">
                  <div class="text">{{ $t('terminal.deviceName') }}：</div>
                  <div class="content" @click="remoteLock" style="cursor: pointer;user-select: none;">{{
                    currentDetail.name }} </div>
                </div>
                <!-- <div class="b_border">
                  <div class="text">{{ $t('terminal.screenType') }}</div>
                  <div class="content">{{ currentDetail.type_remark }}</div>
                </div> -->
                <div class="b_border">
                  <div class="text">{{ $t('terminal.resolution') }}：</div>
                  <div class="content">{{ currentDetail.size_remark }}</div>
                </div>
                <div class="b_border" v-if="currentDetail.remark1 != ''">
                  <div class="text">{{ $t('terminal.remark') }}：</div>
                  <div class="content">{{ currentDetail.remark1 }}</div>
                </div>
                <div class="b_border" v-else>
                  <div class="text">{{ $t('terminal.remark') }}：</div>
                  <div class="content">{{ $t('terminal.noData') }}</div>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.boxTime') }}：</div>
                  <template v-if="currentDetail.time == '暂无数据'">
                    <div class="content">{{ $t('terminal.noData') }}</div>
                  </template>
                  <template v-else>
                    <div class="content">{{ currentDetail.time }}</div>
                  </template>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.currTimeZone') }}：</div>
                  <div class="content" style="display: flex;align-items: center;">
                    <template v-if="this.timeUTC == '暂无数据'">{{ $t('terminal.noData') }}</template>
                    <template v-else>{{ this.timeUTC }}</template>
                    <i class="el-icon-s-tools" v-if="this.timeUTC != '暂无数据'" style="cursor: pointer; margin-left: 20px;"
                      @click="setTime"></i>
                  </div>
                </div>

                <div class="b_border">
                  <el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.deviceLan')"
                    placement="top-start">
                    <div class="text">{{ $t('terminal.deviceLan') }}：</div>
                  </el-tooltip>
                  <div class="content">
                    <template v-if="!currentDetail.deviceLan">{{ $t('terminal.noData') }}</template>
                    <template v-else>{{ currentDetail.deviceLan }}</template>
                  </div>
                </div>

                <div class="b_border" v-if="currentDetail.totalSpace != 0">
                  <div class="text">{{ $t('terminal.deviceZoom') }}：</div>
                  <div class="content">{{ `${(currentDetail.usableSpace / 1024).toFixed(2)}G /
                    ${(currentDetail.totalSpace /
                      1024).toFixed(2)}G` }}</div>
                </div>
                <div class="b_border" v-else>
                  <div class="text">{{ $t('terminal.deviceZoom') }}：</div>
                  <div class="content">{{ $t('terminal.noData') }}</div>
                </div>
                <div class="b_border" v-if="currentDetail.system_version != null && currentDetail.system_version != ''">
                  <div class="text">{{ $t('terminal.version') }}：</div>
                  <div class="content">
                    V{{ currentDetail.system_version }}
                    <i class="el-icon-upload" @click="updateVersion" v-if="currentDetail.system_version != ''"
                      style="margin-left: 20px;cursor: pointer;"></i>
                  </div>
                </div>
                <div class="b_border" v-else>
                  <div class="text">{{ $t('terminal.version') }}：</div>
                  <div class="content">-</div>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.runState') }}：</div>
                  <div class="content">
                    <span :style="'color:' + currentDetail.runStateInfo.stateColor">{{
                      $t(currentDetail.runStateInfo.stateName)
                    }}</span>
                  </div>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.runTime') }}：</div>
                  <div class="content">
                    <template v-if="currentDetail.uptimeMills == '暂无数据'">{{ $t('terminal.noData') }}</template>
                    <template v-else>{{ currentDetail.uptimeMills }}</template>
                  </div>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.lastHeart') }}：</div>
                  <div class="content">
                    <template v-if="currentDetail.last_heartbeat == '暂无数据'">{{ $t('terminal.noData') }}</template>
                    <template v-else>{{ currentDetail.last_heartbeat }}</template>
                  </div>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.timeOrder') }}：</div>
                  <template v-if="isScuduleSettingRuning == '暂无数据'">
                    <div class="content">{{ $t('terminal.noData') }}</div>
                  </template>
                  <template v-else>
                    <div class="content">{{ $t(isScuduleSettingRuning) }}</div>
                  </template>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.timingPlay') }}：</div>
                  <template v-if="!currentDetail.timing_play">
                    <div class="content">{{ $t('terminal.noData') }}</div>
                  </template>
                  <template v-else>
                    <div class="content">{{ currentDetail.timing_play }}</div>
                  </template>
                </div>
                <div class="b_border">
                  <div class="text">{{ $t('terminal.syncPlay') }}：</div>
                  <template v-if="!currentDetail.sync_play">
                    <div class="content">{{ $t('terminal.noData') }}</div>
                  </template>
                  <template v-else>
                    <div class="content">{{ currentDetail.sync_play }}</div>
                  </template>
                </div>
                <div class="b_border" v-if="currentDetail.remote_addr != null && currentDetail.remote_addr != ''">
                  <div class="text">{{ $t('terminal.comAddr') }}：</div>
                  <div class="content">
                    {{ currentDetail.remote_addr }}
                    <i class="el-icon-s-tools" @click="updateRemoteAddr" style="margin-left: 20px;cursor: pointer;"></i>
                  </div>
                </div>
                <div class="b_border" v-else>
                  <div class="text">{{ $t('terminal.comAddr') }}：</div>
                  <div class="content">{{ $t('terminal.noData') }}</div>
                </div>

                <div class="b_border" v-if="currentDetail.sign_input !== undefined && currentDetail.sign_input !== 0">
                  <el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.signalStatus')"
                    placement="top-start">
                    <div class="text">{{ $t('terminal.signalStatus') }}：</div>
                  </el-tooltip>
                  <div class="content">
                    <template v-if="currentDetail.sign_input == 1">{{ $t('terminal.acVa3') }}</template>
                    <template v-if="currentDetail.sign_input == 2">{{ $t('terminal.acVa2') }}</template>
                    <template v-if="currentDetail.sign_input == 3">{{ $t('terminal.acVa1') }}</template>
                  </div>
                </div>
                <div class="b_border" v-else>
                  <div class="text">{{ $t('terminal.signalStatus') }}：</div>
                  <div class="content">{{ $t('terminal.noData') }}</div>
                </div>
              </div>
            </div>
            <div class="open_right">
              <div class="open_img" v-if="switchVedio">
                <div class="img_top" v-loading="imgloading" :element-loading-text="$t('terminal.loading')"
                  v-if="this.currentDetail.run_state" element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)">
                  <el-image style="width: 100%; height: 100%" :z-index="20000" :src="detailImg" fit="contain"
                    class="elimg" ref="pimg"></el-image>
                  <!-- <img src="" class="elimg" style="width: 100%; height: 100%" ref="pimg" /> -->
                </div>
                <div class="img_top" v-else></div>
                <div class="img_bottom">
                  <div>
                    <span style="color: #41f167; cursor: pointer" @click="refreshImg">{{ $t('terminal.refresh')
                    }}</span>
                    <span style="margin-left: 20px;">
                      <span>{{ $t('terminal.least') }}</span>
                      <span style="margin-left: 5px;margin-right: 5px;">{{ this.timeOutNumber }}</span>
                      <span>{{ $t('terminal.milRefresh') }}</span>
                    </span>
                  </div>
                  <span style="color: #41f167; cursor: pointer" @click="openCapture">{{ $t('terminal.viewPho') }}</span>
                </div>
              </div>
              <div class="open_img" v-else>
                <live-vedio :detail="currentDetail" />
              </div>
              <div class="open_control">
                <div class="button">
                  <el-button type="warning" @click="restartCurrentDevice()" size="mini">{{ $t('terminal.reboot')
                  }}</el-button>
                  <el-button type="danger" @click="screenControlDevice('off')" size="mini">{{ $t('ctcdde25')
                  }}</el-button>
                  <el-button type="success" @click="screenControlDevice('on')" size="mini">{{ $t('terminal.onscreen')
                  }}</el-button>
                  <!-- <el-button type="success" size="mini" @click="() => { switchVedio = !switchVedio }">
                    <i class="el-icon-sort" style="transform: rotate(90deg);"></i>
                    {{ switchVedio ? $t('cem11') : $t('cem12') }}
                  </el-button> -->
                </div>
                <div class="light">
                  <div class="text">
                    <span style="white-space: nowrap">{{ $t('terminal.voice') }}：</span>
                  </div>
                  <div class="content">
                    <div class="slider">
                      <el-slider v-model="voice" @change="changeVoice" style="margin-right: 10px"
                        :disabled="!currentDetail.run_state"></el-slider>
                    </div>
                    <!-- <el-input class="input" v-model="cvoice" size="small" @change="changeCvoice"
                    :disabled="!currentDetail.run_state"></el-input>-->
                    <div class="input">
                      <el-input-number class="input" size="small" v-model="cvoice" controls-position="right"
                        @change="changeCvoice" :min="0" :max="100"
                        :disabled="!currentDetail.run_state"></el-input-number>
                    </div>
                  </div>
                </div>
                <div class="light">
                  <div class="text">
                    <span style="white-space: nowrap">{{ $t('terminal.birght') }}：</span>
                  </div>
                  <div class="content">
                    <div class="slider">
                      <el-slider v-model="luminance" @change="changeLuminance" style="margin-right: 10px"
                        :disabled="!currentDetail.run_state"></el-slider>
                    </div>
                    <!-- <el-input class="input" v-model="cluminance" size="small" @change="changeCluminance"
										:disabled="!currentDetail.run_state">
                    </el-input>-->
                    <div class="input">
                      <el-input-number class="input" size="small" v-model="cluminance" controls-position="right"
                        @change="changeCluminance" :min="0" :max="100"
                        :disabled="!currentDetail.run_state"></el-input-number>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="isDetail == 'list'">
        <div class="contents">
          <play-list :currentDetail="currentDetail"></play-list>
        </div>
      </template>
      <template v-if="isDetail == 'power'">
        <div class="contents">
          <relay-control-detail :currentDetail="currentDetail"></relay-control-detail>
        </div>
      </template>
      <template v-if="isDetail == 'schedule'">
        <schedule-list :tableList="this.currentDetail.timeOnOff" :currentDetail="currentDetail"></schedule-list>
      </template>
      <template v-if="isDetail == 'captureList'">
        <capture-list :tableList="this.currentDetail.timeOnOff" :currentDetail="currentDetail"></capture-list>
      </template>
      <template v-if="isDetail == 'live'">
        <live :currentDetail="currentDetail"></live>
      </template>
      <template v-if="isDetail == 'camera'">
        <camera :currentDetail="currentDetail"></camera>
      </template>
      <template v-if="isDetail == 'CentralControl'">
        <CentralControl :currentDetail="currentDetail"></CentralControl>
      </template>
      <template v-if="isDetail == 'PanelMonitoring'">
        <PanelMonitoring :currentDetail="currentDetail"></PanelMonitoring>
      </template>
      <template v-if="isDetail == 'OtherSettings'">
        <OtherSettings :currentDetail="currentDetail"></OtherSettings>
      </template>
      <template v-if="isDetail == 'DeviceGps'">
        <DeviceGps :currentDetail="currentDetail"></DeviceGps>
      </template>
      <template v-if="isDetail == 'DevicePointList'">
        <DevicePointList :currentDetail="currentDetail" />
      </template>
    </div>
    <form-dialog :title="$t('terminal.setTimeZone')" :dialogVisible="timeZoneVisible" @closeDialog="closeTimeZone"
      dWidth="360px" :isAppend="true">
      <div class="time-zone">
        <div class="main">
          <el-select v-model="setTimeZone" @change="changeTimeZone">
            <el-option v-for="item in timezonesList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="footer">
          <el-button @click="timeZoneVisible = false" round>{{ $t('terminal.cancel') }}</el-button>
          <el-button type="primary" @click="confirmTimeZone" round>{{ $t('terminal.confirm') }}</el-button>
        </div>
      </div>
    </form-dialog>
    <form-dialog :dialogVisible="updateVersionVisible" @closeDialog="confirmUpdateVersion" dWidth="900px"
      :isAppend="true" :title="$t('terminal.terminalUp')">
      <div class="update-version">
        <div class="up-header">
          <span style="margin-left: 40px;">{{ $t('terminal.upType') }}</span>
          <div style="margin-left: 40px;">
            <el-radio v-model="upType" label="1">{{ $t('terminal.cloudUp') }}</el-radio>
            <el-radio v-model="upType" label="2">{{ $t('terminal.localUp') }}</el-radio>
          </div>
        </div>
        <template v-if="upType == 2">
          <div class="header1">
            <el-upload class="upload-demo" :headers="MyHeader" action="/api/admin/device/uploadUpdatePackage"
              accept=".zip, .apk" :limit="1" :data="uploadFile" :before-upload="handlePreview"
              :on-success="handle_success">
              <div style="display: flex;">
                <el-button size="small" type="primary">{{ $t('terminal.clickUp') }}</el-button>
              </div>
            </el-upload>
          </div>
        </template>
        <div class="up-content" :class="{ upcontentlocal: upType == 2 }">
          <div class="table-head">
            <div>{{ $t('terminal.name') }}</div>
            <div style="width: 120px;">{{ $t('terminal.type') }}</div>
            <div style="width: 240px;">{{ $t('terminal.verInfo') }}</div>
            <div>{{ $t('terminal.status') }}</div>
            <div>{{ $t('terminal.schedule') }}</div>
          </div>
          <div class="table-body">
            <div class="table-head" style="color: black;">
              <template v-if="this.currentDetail != null">
                <div>{{ this.currentDetail.name }}</div>
                <!-- <div style="width: 120px;">{{ this.currentDetail.model }}</div> -->
                <div style="width: 120px;">{{ this.currentDetail.sn.slice(0, -8) }}</div>
                <template v-if="this.upType == 1">
                  <template v-if="this.updateUrl.length == 0 || this.newVersion == '无需升级'">
                    <div style="width: 240px;">{{ $t('terminal.noUp') }}</div>
                  </template>
                  <template v-else>
                    <div style="width: 240px;" class="textover">{{ `${this.currentDetail.oldVersion}${this.newVersion}`
                    }}
                    </div>
                  </template>
                </template>
                <template v-if="this.upType == 2">
                  <template v-if="this.local_new_version == ''">
                    <div style="width: 240px;" class="textover">{{ `v${this.currentDetail.oldVersion}` }}</div>
                  </template>
                  <template v-else>
                    <el-tooltip :content="`v${this.currentDetail.oldVersion}->${this.local_new_version}`"
                      placement="bottom" effect="light">
                      <div style="width: 240px;" class="textover">
                        {{ `v${this.currentDetail.oldVersion}->${this.local_new_version}` }}</div>
                    </el-tooltip>
                  </template>
                </template>
                <div :style="'color:' + this.currentDetail.runStateInfo.stateColor">
                  {{ $t(this.currentDetail.runStateInfo.stateName) }}</div>
                <div v-if="updateShowFlag == 0">
                  <template v-if="this.updateFlag == -1">{{ $t('terminal.waitStar') }}</template>
                  <template v-if="this.updateFlag == 0">{{ $t('terminal.downExc') }}</template>
                  <template v-if="this.updateFlag == 1">{{ $t('terminal.downOK') }}</template>
                  <template v-if="this.updateFlag == 2">{{ $t('terminal.upTip') }}</template>
                  <template v-if="this.updateFlag == 3">{{ $t('terminal.erroBack') }}</template>
                  <template v-if="this.updateFlag == 4">
                    <el-progress :percentage="percent"></el-progress>
                  </template>
                </div>
                <div v-if="updateShowFlag == 1">
                  <template v-if="this.updateFlag == -1">{{ $t('terminal.waitStar') }}</template>
                  <template v-if="this.updateFlag == 0">{{ $t('terminal.downExc') }}</template>
                  <template v-if="this.updateFlag == 2">{{ $t('terminal.erroBack') }}</template>
                  <template v-if="this.updateFlag == 3">{{ $t('terminal.downOK') }}</template>
                  <template v-if="this.updateFlag == 4 || this.updateFlag == 5">{{ this.downMessage }}</template>

                  <template v-if="this.updateFlag == 1">
                    <el-progress :percentage="percent"></el-progress>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="up-footer">
          <span style="margin-left: 20px;">{{ $t('terminal.dowNum') }}</span>
          <span style="margin-left: 50px;color: #617883;">
            {{ $t('terminal.upTips1') }}
            <span style="color: red;">{{ $t('terminal.upTips2') }}</span>
          </span>
          <template v-if="this.upType == 1">
            <el-button type="primary" style="margin-left: 50px;" @click="confirmUpdate" round
              :disabled="this.updateUrl.length == 0 || this.newVersion == '无需升级' && this.upType == 1">{{
                $t('terminal.upGr') }}</el-button>
          </template>
          <template v-if="this.upType == 2">
            <el-button type="primary" style="margin-left: 50px;" @click="confirmUpdate" round
              :disabled="this.localUrl == ''">{{ $t('terminal.upGr') }}</el-button>
          </template>
        </div>
      </div>
    </form-dialog>
    <form-dialog :title="$t('terminal.serverAddEdit')" :dialogVisible="updateRemoteAddrVisible"
      @closeDialog="closeRemoteAddr" :isAppend="true" dWidth="450px">
      <div class="remote-addr">
        <div>{{ $t('terminal.serEdTit') }}</div>
        <div class="newaddr" style="position: relative;">
          <div class="label">{{ $t('terminal.newAddr') }}</div>
          <el-input class="inputs" v-model="newAddr"></el-input>
          <el-button style="margin-left: 10px;" @click="testAddr">{{ $t('terminal.test') }}</el-button>
          <span class="tips" v-show="this.testCode != -200">{{ this.testMessage }}</span>
        </div>
        <div class="newaddr">
          <div class="label">{{ $t('terminal.user') }}</div>
          <el-input class="inputs" v-model="username" required></el-input>
        </div>
        <div class="newaddr">
          <div class="label">{{ $t('terminal.psw') }}</div>
          <el-input class="inputs" v-model="userpsw" show-password required></el-input>
        </div>
        <div>
          <el-button type="primary submit" @click="confirmAddr" round
            :disabled="isTestOk || this.username == '' || this.userpsw == ''">{{ $t('terminal.remove') }}</el-button>
          <el-button @click="cancelAddr" round>{{ $t('terminal.cancel') }}</el-button>
        </div>
      </div>
    </form-dialog>
    <form-dialog :title="$t('ctcdde33')" :dialogVisible="remoteLockVisible" @closeDialog="closeRemoteLock"
      :isAppend="true" dWidth="500px">
      <remote-lock :currentDetail="currentDetail" />
    </form-dialog>
    <del-dialog :title="$t('terminal.conRes')" :dialogVisible="restartVisible" @closeDialog="confirmRestart"
      :isAppend="true"></del-dialog>
    <del-dialog :title="$t('terminal.conOnSc')" :dialogVisible="openVisible" @closeDialog="screenControl"
      :isAppend="true"></del-dialog>
    <del-dialog :title="$t('ctcdde25')" :dialogVisible="closeVisible" @closeDialog="screenControl"
      :isAppend="true"></del-dialog>
    <div class="mask-overall" v-if="showMask">
      <!-- 遮罩层里面的内容 -->
      <div class="content" v-loading="caputer_img_loading" :element-loading-text="$t('terminal.loading')"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">
        <template v-if="caputer_raw_show">
          <!-- <el-image style="width: 100%; height: 100%" :src="caputer_raw_img"  fit="contain"></el-image> -->
          <img style="width: 100%; height: 100%" :src="caputer_raw_img" />
        </template>
      </div>
      <div class="mask-main">
        <i class="el-icon-circle-close" @click="closeMsk()"></i>
      </div>
    </div>
  </enfold>
</template>

<script>
const detailCommand = "/admin/Command/deviceCommand";
//const generalCommand = "/admin/command/generalCommand";
import FormDialog from "@/components/basics/FormDialogConfirm";
import Enfold from "@/components/basics/Enfold";
import RelayControlDetail from "./item/RelayControlDetail";
import RemoteLock from "./item/RemoteLock";
import {
  formatDate,
  formatHMS,
  sendCommandKp
} from "@/assets/scripts/publicFunction";
import {
  uriEncode
} from "@/assets/scripts/uriEncode";
import timezones from "@static/data/timezones";
import {
  handleDataAndSign
} from "@/assets/scripts/handleDataAndSign";

import DelDialog from "@/components/basics/DelDialogConfirm";
import ScheduleList from "./item/ScheduleList";
import CaptureList from "./item/CaptureList";
import PlayList from "./item/PlayList";
import Live from "./item/Live";
import Camera from "./item/Camera";
import CentralControl from "./item/CentralControl"
import OtherSettings from "@/components/terminal/children/item/OtherSettings";
import DeviceGps from "@/components/terminal/children/item/DeviceGps";
import DevicePointList from "@/components/terminal/children/item/DevicePointList";
import PanelMonitoring from "@/components/terminal/children/item/PanelMonitoring";
import LiveVedio from "@/components/basics/Live";
import translate from "./tools/translate.js";

export default {
  name: 'DeviceDetailOpen',
  props: {
    currentDetail: {
      type: Object
    }
  },
  components: {
    Enfold,
    FormDialog,
    DelDialog,
    PlayList,
    RelayControlDetail,
    ScheduleList,
    CaptureList,
    Live,
    Camera,
    CentralControl,
    PanelMonitoring,
    OtherSettings,
    DeviceGps,
    RemoteLock,
    LiveVedio,
    DevicePointList
  },
  data() {
    return {
      dcInfoCache: null,
      isDetail: 'detail',
      timeUTC: '暂无数据',
      currentTimeZoneId: '',
      caputer_raw_show: true,
      detailTimeOutFlag: true,
      caputer_img_loading: false,
      isScuduleSettingRuning: '暂无数据',
      caputer_raw_img: "",
      localUrl: '',
      newAddr: '',
      testCode: -200,
      testMessage: '',
      setTimeZone: '',
      username: '',
      userpsw: '',
      imgloading: false,
      timeZoneVisible: false,
      detailImg: '',
      showMask: false,
      rawInter: null,
      timeOutNumber: 60,
      restartVisible: false,
      openVisible: false,
      closeVisible: false,
      voice: 0,
      cvoice: 0,
      luminance: 0,
      cluminance: 0,
      timezonesList: timezones,
      updateVersionVisible: false,
      updateRemoteAddrVisible: false,
      upType: "1",
      updateShowFlag: 0, //升级进度区分显示 0-sent_update_sys 1-apl-down-process
      MyHeader: {},
      uploadFile: {},
      updateUrl: [],
      newVersion: '',
      local_new_version: '',
      fileSize: '',
      updateFlag: -1,
      downMessage: "",
      percent: 0,
      isTestOk: true,
      remoteLockNum: 0,
      remoteLockTimeout: 0,
      remoteLockVisible: false,
      switchVedio: true,
      CPT: process.env.VUE_APP_CPT
    }
  },
  methods: {
    remoteLock() {
      this.remoteLockNum += 1;
      clearTimeout(this.remoteLockTimeout);
      this.remoteLockTimeout = setTimeout(() => {
        if (this.remoteLockNum === 5) {
          this.remoteLockVisible = true;
        }
        this.remoteLockNum = 0;
      }, 2000);
    },
    closeRemoteLock() {
      this.remoteLockVisible = false;
    },
    handlePreview() {
      let formData = {};
      let data = handleDataAndSign("/admin/device/uploadUpdatePackage", formData);
      //this.uploadFile.token = this.$cookies.get("token");
      this.uploadFile.v = data.v;
      this.uploadFile.t = data.t;
      this.uploadFile.token = data.token;
      this.uploadFile.s = data.s;
    },
    handle_success(data, file) {
      this.localUrl = data.data.url;
      //let index = this.localUrl.indexOf('local');
      //let localV = this.localUrl.slice(index + 6, this.localUrl.length - 4);
      this.local_new_version = file.name;
      this.fileSize = file.size;
      console.log('上传完成', file)
    },
    confirmUpdate() {
      let upurl = '';
      let dcObj = {
        id: this.currentDetail.id,
        sn: this.currentDetail.sn,
        type_id: this.currentDetail.type_id,
        name: this.currentDetail.name,
        myData: {
          url: upurl,
          web_uid: 'media_user_' + this.$cookies.get('user_id')
        },
        cache: {}
      };
      if (this.upType == 1) {
        upurl = this.updateUrl[this.updateName];
        dcObj.myData.url = upurl;
        // this.$http.post("/admin/command/generalCommand", {
        // 	device_select_mode: "multiple",
        // 	devices_info: uriEncode([{
        // 		id: this.currentDetail.id,
        // 		sn: this.currentDetail.sn,
        // 		type_id: this.currentDetail.type_id,
        // 		name: this.currentDetail.name,
        // 		myData: {
        // 			url: upurl,
        // 			web_uid: 'media_user_' + this.$cookies.get('user_id')
        // 		},
        // 		cache: {}
        // 	}]),
        // 	request_type:'get',
        // 	commands_info: uriEncode([{
        // 		type: "updateSys",
        // 		data: {}
        // 	}]),
        // });
        sendCommandKp('multiple', [dcObj], "get", {}, 'updateSys');
      } else {
        upurl = this.localUrl;
        dcObj.myData.url = upurl;
        let type = upurl.slice(upurl.length - 3, upurl.length);
        if (type == 'zip') {
          // this.$http.post("/admin/command/generalCommand", {
          // 	device_select_mode: "multiple",
          // 	devices_info: uriEncode([{
          // 		id: this.currentDetail.id,
          // 		sn: this.currentDetail.sn,
          // 		type_id: this.currentDetail.type_id,
          // 		name: this.currentDetail.name,
          // 		myData: {
          // 			url: upurl,
          // 			web_uid: 'media_user_' + this.$cookies.get('user_id')
          // 		},
          // 		cache: {}
          // 	}]),
          // 	request_type: 'get',
          // 	commands_info: uriEncode([{
          // 		type: "updateSys",
          // 		data: {}
          // 	}]),
          // });
          this.updateShowFlag = 0;
          sendCommandKp('multiple', [dcObj], "get", {}, 'updateSys');
        } else if (type == 'apk') {
          //apk升级...
          dcObj.myData.fileLength = this.fileSize;
          this.updateShowFlag = 1;
          sendCommandKp('multiple', [dcObj], "get", {}, 'updateApk');
          // this.$http.post("/admin/command/generalCommand", {
          // 	device_select_mode: "multiple",
          // 	devices_info: uriEncode([{
          // 		id: this.currentDetail.id,
          // 		sn: this.currentDetail.sn,
          // 		type_id: this.currentDetail.type_id,
          // 		name: this.currentDetail.name,
          // 		myData: {
          // 			fileLength: this.fileSize,
          // 			url: upurl,
          // 			web_uid: 'media_user_' + this.$cookies.get('user_id')
          // 		},
          // 		cache: {}
          // 	}]),
          // 	request_type: 'get',
          // 	commands_info: uriEncode([{
          // 		type: "updateApk",
          // 		data: {}
          // 	}]),
          // });
        } else {
          this.$msg({
            type: 'warning',
            message: this.$t('terminal.upTips3')
          })
        }
        console.log("type??", type)
      }
      this.myWebSocket.onmessage = (val) => {
        //console.log("websocket??",JSON.parse(val.data))
        let upresult = JSON.parse(val.data);
        if (upresult.type == "send_update_sys") {
          //console.log(this.upresult.data.status)
          this.updateFlag = upresult.data.status;
          if (upresult.data.status == 4) {
            this.percent = Math.round(upresult.data.params.downloaded * 100);
          }
        }
        if (upresult.type == "download_apk_process") {
          //console.log(this.upresult.data.status)
          this.updateFlag = upresult.data.status;
          this.downMessage = upresult.data.message;
          if (upresult.data.status == 1) {
            this.percent = upresult.data.params.downloaded <= 100 ? Math.round(upresult.data.params
              .downloaded) :
              100;
            if (upresult.data.params.downloaded >= 100) {
              this.updateFlag = 3;
            }
          }
        }
      }
      // this.myWebSocket.onmessage = (val) => {
      // 	//console.log(JSON.parse(val.data))
      // 	let upresult = JSON.parse(val.data);
      // 	if (upresult.type == "download_apk_process") {
      // 		//console.log(this.upresult.data.status)
      // 		this.updateFlag = upresult.data.status;
      // 		this.downMessage = upresult.data.message;
      // 		if (upresult.data.status == 1) {
      // 			this.percent = upresult.data.params.downloaded <= 100 ? upresult.data.params.downloaded :
      // 				100;
      // 			if (upresult.data.params.downloaded >= 100) {
      // 				this.updateFlag = 3;
      // 			}
      // 		}
      // 	}
      // }
    },
    confirmUpdateVersion() {
      this.updateVersionVisible = false;
      this.local_new_version = '';
      this.upType = '1';
      this.updateShowFlag = 0;
    },
    changeDetail(value) {
      this.isDetail = value
    },
    async refreshImg() {
      if (this.currentDetail.system_version != null) {
        let flagIndex = this.currentDetail.system_version.lastIndexOf("-")
        let version = parseInt(this.currentDetail.system_version.slice(flagIndex + 1))
        this.timeOutNumber = 60;
        if (this.currentDetail.run_state) {
          this.imgloading = true;

          await this.getDetailCaputerImg("capture");
          await sendCommandKp('multiple', this.dcInfoCache, "get", { methodName: "getScreenParams", methodParams: {} });
          //await this.getDetailCaputerImg("capture_raw");
          if (version < 299) {
            this.deleteInter = setInterval(() => {

              if (this.isImgDelete == true) {
                //console.log('删除成功.....')
                this.$nextTick(() => {
                  let url =
                    "/upload/capture/d_" +
                    this.currentDetail.id +
                    "/" +
                    "device_" +
                    this.currentDetail.id +
                    "_capture.png?t=" +
                    new Date().getTime();
                  var temp = new Image();
                  temp.src = url;
                  temp.onload = () => {
                    this.detailImg = url;
                    this.srcList = [
                      "/upload/capture/d_" +
                      this.currentDetail.id +
                      "/" +
                      "device_" +
                      this.currentDetail.id +
                      "_capture_raw.png?t=" +
                      new Date().getTime(),
                    ];
                    this.isImgDelete = false;
                    clearInterval(this.deleteInter);
                    this.imgloading = false;
                  };
                  temp.onerror = () => {
                    this.srcList = [];
                  }
                });
              }
            }, 1000)
          } else {
            //大于300 用websocket接收图片
            this.myWebSocket.onmessage = (val) => {
              let data = JSON.parse(val.data);
              // console.log(data.data);
              if (data.type == "capture" && data.pandora_id == this.currentDetail.id) {
                let url =
                  "/upload/capture/d_" +
                  this.currentDetail.id +
                  "/" +
                  "device_" +
                  this.currentDetail.id +
                  "_capture.png?t=" +
                  new Date().getTime();
                this.detailImg = url;
                this.isImgDelete = false;
                this.imgloading = false;
              }
              const { uri, response } = data.data;
              if (uri === "getScreenParams") {
                if (JSON.parse(response).screenOn) {
                  this.currentDetail.runStateInfo = {
                    stateColor: "#00ae00",
                    stateName: "terminal.onscreen"
                  }
                } else {
                  this.currentDetail.runStateInfo = {
                    stateColor: "#00ae00",
                    stateName: "terminal.action4"
                  }
                }
                // console.log(this.currentDetail.runStateInfo);
              }
            }
          }
        }
      }
    },
    restartCurrentDevice() {
      this.restartVisible = true;
    },
    confirmRestart(isConfirm) {
      if (isConfirm) {
        sendCommandKp('multiple', this.dcInfoCache, "get", {}, 'restart_control');
      }
      this.restartVisible = false;
    },
    screenControl(isConfirm) {
      if (isConfirm) {
        let type = this.openVisible ? 'onscreen_control' : this.closeVisible ? 'offscreen_control' : '';
        sendCommandKp('multiple', this.dcInfoCache, "get", {}, type);
      }
      this.openVisible = false;
      this.closeVisible = false;
    },
    screenControlDevice(type) {
      if (type === 'on') { this.openVisible = true; }
      if (type === 'off') { this.closeVisible = true; }
      setTimeout(() => {
        this.refreshImg()
      }, 3000);
    },
    saveVoice() {
      let commands_info = [{
        device_id: this.currentDetail.id,
        sn: this.currentDetail.sn,
        msg: {
          id: this.currentDetail.id,
          data: {
            value: (this.voice / 100).toFixed(2),
          },
          type: "voice",
        },
      },];
      this.$http.post(detailCommand, {
        commands_info: uriEncode(commands_info),
      },
        (data) => {
          console.log(data);
        }
      );
    },
    saveBright() {
      let commands_info = [{
        device_id: this.currentDetail.id,
        sn: this.currentDetail.sn,
        msg: {
          id: this.currentDetail.id,
          data: {
            value: this.luminance,
          },
          type: "bright",
        },
      },];

      this.$http.post(
        detailCommand, {
        commands_info: uriEncode(commands_info),
      },
        (data) => {
          console.log(data);
        }
      );
    },
    changeVoice() {
      this.cvoice = parseInt(this.voice);
      this.saveVoice();
    },
    changeCvoice() {
      this.voice = Number(this.cvoice);
      this.saveVoice();
    },
    changeLuminance() {
      this.cluminance = parseInt(this.luminance);
      this.saveBright();
    },
    changeCluminance() {
      this.luminance = parseInt(this.cluminance);
      this.saveBright();
    },
    testAddr() {
      let index = this.currentDetail.system_version.indexOf('-');
      let real_version = this.currentDetail.system_version.slice(index + 1, this.currentDetail.system_version
        .length)
      console.log(real_version)
      if (real_version > 218) {
        sendCommandKp('multiple', this.dcInfoCache, "get", {
          methodName: "testHttp",
          methodParams: {
            url: this.newAddr
          }
        });

      } else {
        let user_id = this.$cookies.get("user_id");
        this.$http.post(detailCommand, {
          commands_info: uriEncode([{
            device_id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            msg: {
              id: this.currentDetail.id,
              sn: this.currentDetail.sn,
              groupName: user_id,
              type: "test_http",
            },
          },]),
        })
      }
      this.myWebSocket.onmessage = (val) => {
        let res = JSON.parse(val.data);
        let result = JSON.parse(res.data.response);
        this.testCode = result.responseCode;
        if (result.responseCode === 0) {
          //console.log('测试通过');
          this.isTestOk = false;
          this.testMessage = this.$t('terminal.testOk')
        } else {
          this.isTestOk = true;
          this.testMessage = this.$t('terminal.testFail')
        }
        //console.log(result)
      }
    },
    async confirmAddr() {
      //let isAddOtherCloud = false;
      //let isSetHost = false;
      //let result_id = -1;
      if (this.username == '' || this.userpsw == '') {
        this.$msg({
          message: this.$t('terminal.inputTips1'),
          type: 'warning'
        });
      } else {
        console.log(this.currentDetail.type_id)
        await this.$http.post('/admin/device/addDevByCloudOthers', {
          username: this.username,
          password: this.userpsw,
          name: this.currentDetail.name,
          sn: this.currentDetail.sn,
          size_remark: this.currentDetail.size_remark,
          type_id: this.currentDetail.type_id,
          url: this.newAddr
        });

        let host = this.newAddr;
        let https_index = this.newAddr.indexOf('https://');
        let https_index1 = this.newAddr.indexOf('https:/');
        let https_index2 = this.newAddr.indexOf('https:');

        let http_index = this.newAddr.indexOf('http://');
        let http_index1 = this.newAddr.indexOf('http:/');
        let http_index2 = this.newAddr.indexOf('http:');

        let real_host = '';
        if (https_index != -1) {
          real_host = host.slice(https_index + 8, host.length);
          //console.log('real_host', real_host)
        } else if (https_index1 != -1) {
          real_host = host.slice(https_index1 + 7, host.length);
        } else if (https_index2 != -1) {
          real_host = host.slice(https_index2 + 6, host.length);
        } else if (http_index != -1) {
          //console.log('http_index', http_index)
          real_host = host.slice(http_index + 7, host.length);
          //console.log('real_host', real_host)
        } else if (http_index1 != -1) {
          real_host = host.slice(http_index1 + 6, host.length);
        } else if (http_index2 != -1) {
          real_host = host.slice(http_index2 + 5, host.length);
        }

        let win_index = real_host.indexOf(':');
        if (win_index != -1) {
          real_host = real_host.slice(0, win_index);
        }

        let res = await sendCommandKp('multiple', this.dcInfoCache, "set", {
          methodName: "setKaresHost",
          methodParams: {
            host: real_host
          }
        });
        res && this.$msg({
          type: "success",
          message: this.$t('terminal.opOk')
        })

        const group_ids = sessionStorage.getItem('group_ids');
        this.$http.post('/admin/device/list', {
          group_ids: group_ids,
          limit: this.limit,
          page: this.page
        }, data => {
          data.list.forEach(ele => {
            if (ele.id == this.currentDetail.id) {
              this.currentDetail.remote_addr = ele.remote_addr;
            }
          })
        })
        this.updateRemoteAddrVisible = false;
      }
    },
    cancelAddr() {
      this.updateRemoteAddrVisible = false;
    },
    closeRemoteAddr() {
      this.updateRemoteAddrVisible = false;
      this.newAddr = '';
      this.username = '';
      this.userpsw = '';
      this.testMessage = '';
      this.testCode = -200;
    },
    close() {
      this.$emit('closeOpenDetail');
    },
    setTime() {
      this.setTimeZone = this.currentTimeZoneId;
      this.timeZoneVisible = true;
    },
    changeTimeZone(val) {
      this.currentTimeZoneId = val;
    },
    updateUtc() {
      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getCurTime",
        methodParams: {}
      });
      this.myWebSocket.onmessage = (val) => {
        if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri ==
          'getCurTime') {
          let data = JSON.parse(val.data);
          if (data.data.response != undefined) {
            let utc = JSON.parse(data.data.response)
            this.currentTimeZoneId = utc.timeZoneId;
            this.timezonesList.forEach((val) => {
              if (val.id == this.currentTimeZoneId) {
                this.timeUTC = val.label;
              }
            })
            this.detailLoading = false;
          }
        }
      }
    },
    confirmTimeZone() {
      sendCommandKp('multiple', this.dcInfoCache, "set", {
        methodName: "setTimeZoneId",
        methodParams: {
          timeZoneId: this.currentTimeZoneId
        }
      });
      this.timeZoneVisible = false;
      this.updateUtc();
    },
    closeTimeZone() {

    },
    updateVersion() {
      let index = this.currentDetail.system_version.indexOf('-');
      let sys_ver = this.currentDetail.system_version.slice(0, index);
      //console.log('参数', sys_ver)
      this.currentDetail.oldVersion = sys_ver;
      this.$http.post('/admin/device/getUpdatePackageInfo', {
        devicesInfo: uriEncode([{
          device_model: this.currentDetail.model,
          sys_ver: sys_ver
          // sys_ver:"1.3.3"
        }])
      }, data => {
        //console.log(data)
        this.updateUrl = data;
        let old = Object.keys(data);
        this.updateName = old[0];
        //console.log(old[0])
        let temp = data[old[0]];
        //console.log('temp')
        let index = temp.indexOf(old[0]);
        let _index = temp.indexOf(old[0] + '_')
        if (index == -1) {
          //console.log('没有的情况...,直接判断文件名，升级');
          let kp_index = temp.indexOf('update-');
          let file_name = temp.slice(kp_index + 7, temp.length)
          //console.log('file_name', file_name)
          let first_index = file_name.indexOf('-');
          let last_index = file_name.lastIndexOf('-')
          let v_name = file_name.slice(first_index + 1, last_index);
          this.newVersion = '->' + v_name;
          //console.log(v_name)
        } else {
          if (_index == -1) {
            //正常情况
            this.newVersion = '无需升级';
          } else {
            let news = temp.slice(index + old[0].length + 1, temp.length)
            //console.log('news', news)
            let lastindex = news.indexOf('-');
            this.newVersion = '->' + news.slice(0, lastindex);
            let oldv = old[0].slice(0, old[0].length - 1);
            let oldindex = oldv.lastIndexOf('-');
            this.oldVersion = oldv.slice(oldindex + 1, oldv.length + 1);
          }
        }

      })
      this.updateVersionVisible = true;
    },
    updateRemoteAddr() {
      this.updateRemoteAddrVisible = true;
    },
    getDetailCaputerImg(type) {
      this.imgloading = true;
      this.$http.post("/admin/command/capture", {
        command: type,
        devices_info: uriEncode([{
          id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          type_id: this.currentDetail.type_id,
        },]),
      }, data => {
        if (data.length == 0) {
          this.isImgDelete = true;
        }

      });
    },
    async getOnlineDeviceDetail() {
      let user_id = this.$cookies.get("user_id");
      let get_device_info = true;
      let invoke_method = true;
      let get_setting_schedule = true;
      let version = this.currentDetail.system_version.split('-')[1];
      console.log("version", version)
      //await this.getSettingSchedule();
      this.detailLoading = true;
      this.$http.post(
        detailCommand, {
        commands_info: uriEncode([{
          device_id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          msg: {
            id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            groupName: user_id,
            type: "get_device_info",
          },
        },]),
      }
      );

      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getCurTime",
        methodParams: {}
      });

      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "isScheduleSettingRunning",
        methodParams: {}
      });

      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getSignalInput",
        methodParams: {}
      });

      version >= 260 && sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getDeviceInfo",
        methodParams: {}
      });

      sendCommandKp('multiple', this.dcInfoCache, "get", {
        methodName: "getLanguages",
        methodParams: {}
      });

      this.$http.post(
        detailCommand, {
        commands_info: uriEncode([{
          device_id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          msg: {
            id: this.currentDetail.id,
            sn: this.currentDetail.sn,
            groupName: user_id,
            type: "get_setting_schedule",
          },
        },]),
      }
      );

      setTimeout(() => {
        if (this.detailLoading == true) {
          get_device_info = false;
          invoke_method = false;
          get_setting_schedule = false;
          this.currentDetail.uptimeMills = "暂无数据"
        }
        this.detailLoading = false;
      }, 3000)
      this.myWebSocket.onmessage = (val) => {
        let devices_info;
        if (JSON.parse(val.data).type == "get_device_info") {
          devices_info = JSON.parse(val.data);
          this.voice = parseInt(devices_info.data.device.voice * 100);
          this.luminance = devices_info.data.bright;
          this.cluminance = devices_info.data.bright;
          this.cvoice = parseInt(devices_info.data.device.voice * 100);
          this.subModel = devices_info.data.device.subModel;
          this.currentDetail.totalSpace =
            devices_info.data.device.totalSpace;
          this.currentDetail.usableSpace =
            devices_info.data.device.usableSpace;
          this.currentDetail.uptimeMills = formatHMS(
            devices_info.data.uptimeMills,
            ":",
            false,
            false
          );
          this.currentDetail.remote_addr = devices_info.data.device.remote_addr;
          if (devices_info.data.time === "0") {
            this.currentDetail.time = "--";
          } else {
            this.currentDetail.time = formatDate(
              new Date(devices_info.data.time),
              "yyyy-MM-dd hh:mm:ss"
            );
          }
          get_device_info = false;
          this.detailLoading = get_device_info || invoke_method || get_setting_schedule;
        } else if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri ==
          'getCurTime') {
          let data = JSON.parse(val.data);
          if (data.data.response != undefined) {
            let utc = JSON.parse(data.data.response)
            this.currentTimeZoneId = utc.timeZoneId;
            this.timezonesList.forEach((val) => {
              if (val.id == this.currentTimeZoneId) {
                this.timeUTC = val.label;
              }
            })
            invoke_method = false;
            this.detailLoading = get_device_info || invoke_method || get_setting_schedule;
          }
        } else if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri ==
          'isScheduleSettingRunning') {
          let data = JSON.parse(val.data);
          let res = JSON.parse(data.data.response);
          if (res.isRunning) {
            this.isScuduleSettingRuning = 'terminal.opend'; //开
          } else {
            this.isScuduleSettingRuning = 'terminal.closed'; //关
          }
        } else if (JSON.parse(val.data).type == "get_setting_schedule") {
          let schedule_info;
          schedule_info = JSON.parse(val.data);
          this.currentDetail.timeOnOff = schedule_info.data;
          get_setting_schedule = false;
          this.detailLoading = get_device_info || invoke_method || get_setting_schedule;
        } else if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri ==
          'getDeviceInfo') {
          let dcInfo = JSON.parse(JSON.parse(val.data).data.response);
          let dcArray = dcInfo.data.split('\n'); //由于返回的是字符串,根据换行分成数组
          let deviceInfo = [];
          dcArray.forEach(ele => {
            deviceInfo.push({
              type: ele.split('：')[0], //收到的冒号是中文下的
              data: translate(ele.split('：')[1], this)
            })
          })
          deviceInfo.forEach(ele => {
            switch (ele.type) {
              case "定时播放":
                this.currentDetail.timing_play = ele.data; //定时播放
                break;
              case "WIFI网络":
              case "有线网络":
                this.currentDetail.remote_addr = ele.data;
                break;
              case "同步播放":
                this.currentDetail.sync_play = ele.data;
                break;
            }
          })
        } else if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri ==
          'getSignalInput') {
          let signInput = JSON.parse(JSON.parse(val.data).data.response);
          this.currentDetail.sign_input = signInput.input;
        } else if (JSON.parse(val.data).type == "invoke_method" && JSON.parse(val.data).data.uri ==
          'getLanguages') {
          let lanlist = JSON.parse(JSON.parse(val.data).data.response);
          this.currentDetail.deviceLan = lanlist.data[0].zhName;
        } else if (JSON.parse(val.data).type == "capture" && JSON.parse(val.data).pandora_id == this
          .currentDetail.id) {
          let url =
            "/upload/capture/d_" +
            this.currentDetail.id +
            "/" +
            "device_" +
            this.currentDetail.id +
            "_capture.png?t=" +
            new Date().getTime();
          this.detailImg = url;
          this.isImgDelete = false;
          this.imgloading = false;
          console.log("websocket截图")
        }
      };

    },
    getCaputerRawImg(type) {
      this.caputer_raw_show = false;
      this.caputer_img_loading = true;
      let version = this.currentDetail.system_version.split('-')[1];
      this.$http.post("/admin/command/capture", {
        command: type,
        devices_info: uriEncode([{
          id: this.currentDetail.id,
          sn: this.currentDetail.sn,
          type_id: this.currentDetail.type_id,
        },]),
      }, data => {
        console.log(data)
        if (version < 299) {
          this.srcList = [];
          this.timeOutNumber = 60;
          var temp = new Image();
          let timeflag = new Date().getTime();
          this.rawInter = setInterval(() => {
            let url =
              "/upload/capture/d_" +
              this.currentDetail.id +
              "/" +
              "device_" +
              this.currentDetail.id +
              "_capture_raw.png?t=" +
              timeflag;
            temp.src = url;
          }, 500)
          this.$nextTick(() => {
            temp.onload = () => {
              //console.log('原图更新...', this.srcList)
              this.caputer_raw_img = "/upload/capture/d_" +
                this.currentDetail.id +
                "/" +
                "device_" +
                this.currentDetail.id +
                "_capture_raw.png?t=" +
                new Date().getTime();
              this.detailImg = "/upload/capture/d_" +
                this.currentDetail.id +
                "/" +
                "device_" +
                this.currentDetail.id +
                "_capture.png?t=" +
                new Date().getTime();
              this.imgloading = false;
              clearInterval(this.rawInter);
              this.caputer_img_loading = false;
              this.caputer_raw_show = true;
            };
          })
        } else {
          this.srcList = [];
          this.timeOutNumber = 60;
          this.myWebSocket.onmessage = (val) => {
            let res = JSON.parse(val.data);
            if (res.type == "capture_raw" && res.pandora_id == this.currentDetail.id) {
              this.caputer_raw_img = "/upload/capture/d_" +
                this.currentDetail.id +
                "/" +
                "device_" +
                this.currentDetail.id +
                "_capture_raw.png?t=" +
                new Date().getTime();
              this.detailImg = "/upload/capture/d_" +
                this.currentDetail.id +
                "/" +
                "device_" +
                this.currentDetail.id +
                "_capture.png?t=" +
                new Date().getTime();
              this.imgloading = false;
              this.caputer_img_loading = false;
              this.caputer_raw_show = true;
            }
          }
        }
      });
    },
    async openCapture() {
      if (this.currentDetail.run_state) {
        this.showMask = true;
        this.getCaputerRawImg("capture_raw");
      }
    },
    closeMsk() {
      this.showMask = false;
      clearInterval(this.rawInter);
    },
    async getDeviceDetail() {
      if (this.currentDetail.system_version != null) {
        if (this.currentDetail.run_state) {
          this.timeOutNumber = 60;
          this.imgloading = true;
          await this.getDetailCaputerImg("capture");
          this.getOnlineDeviceDetail();
          let flagIndex = this.currentDetail.system_version.lastIndexOf("-")
          let version = parseInt(this.currentDetail.system_version.slice(flagIndex + 1))
          if (version < 299) {
            this.deleteInter = setInterval(() => {
              if (this.isImgDelete == true) {
                this.$nextTick(() => {
                  let url =
                    "/upload/capture/d_" +
                    this.currentDetail.id +
                    "/" +
                    "device_" +
                    this.currentDetail.id +
                    "_capture.png?t=" +
                    new Date().getTime();
                  var temp = new Image();
                  temp.src = url;
                  //console.clear();
                  temp.onload = () => {
                    this.detailImg = url;
                    this.imgloading = false;
                    clearInterval(this.deleteInter)
                  };
                  temp.onerror = () => {
                    this.srcList = [];
                  }
                });
              }
            }, 1000);
          }

        } else {
          this.currentDetail.uptimeMills = "暂无数据";
          this.currentDetail.time = "暂无数据";
          this.voice = 0;
          this.luminance = 0;
          this.cluminance = 0;
          this.cvoice = 0;
        }
      } else {
        this.currentDetail.time = "暂无数据";
        this.currentDetail.uptimeMills = "暂无数据";
        this.voice = 0;
        this.luminance = 0;
        this.cluminance = 0;
        this.cvoice = 0;
      }
      if (this.currentDetail.last_heartbeat == 0) {
        this.currentDetail.last_heartbeat = "暂无数据";
      } else {
        this.currentDetail.last_heartbeat =
          typeof this.currentDetail.last_heartbeat == "number" ?
            formatDate(
              new Date(this.currentDetail.last_heartbeat * 1000),
              "yyyy-MM-dd hh:mm:ss"
            ) :
            this.currentDetail.last_heartbeat;
      }
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  beforeDestroy() {
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.detailTimeOut);
      clearInterval(this.deleteInter);
      this.detailTimeOut = null;
      this.deleteInter = null;
    })
  },
  created() {
    this.dcInfoCache = [{
      id: this.currentDetail.id,
      sn: this.currentDetail.sn,
      type_id: this.currentDetail.type_id,
      name: this.currentDetail.name,
      cache: {}
    }];
    this.getDeviceDetail();
    //this.isScuduleSettingRun();
    if (this.currentDetail != null) {
      if (this.currentDetail.run_state && this.detailTimeOutFlag) {
        this.detailTimeOut = setInterval(() => {
          this.timeOutNumber -= 1;
          if (this.timeOutNumber == 0) {
            this.refreshImg();
            // this.getDetailCaputerImg('capture');
            // this.$nextTick(() => {
            // 	let url =
            // 		"/upload/capture/d_" +
            // 		this.currentDetail.id +
            // 		"/" +
            // 		"device_" +
            // 		this.currentDetail.id +
            // 		"_capture.png?t=" +
            // 		new Date().getTime();
            // 	let temp = new Image();
            // 	temp.src = url;
            // 	temp.onload = () => {
            // 		this.detailImg = url;

            // 		this.srcList = [
            // 			"/upload/capture/d_" +
            // 			this.currentDetail.id +
            // 			"/" +
            // 			"device_" +
            // 			this.currentDetail.id +
            // 			"_capture_raw.png?t=" +
            // 			new Date().getTime(),
            // 		];
            // 		this.imgloading = false;
            // 	};
            // 	temp.onerror = () => {
            // 		this.srcList = [];
            // 		this.imgloading = false;
            // 	}
            // })
            // this.timeOutNumber = 60;
          }
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.device-detail-open {
  width: 100%;
  height: 100%;
  background-color: white;

  .detailActive {
    // background-image: linear-gradient(270deg,
    //     #72e0ea 0%,
    //     #59d3ee 45%,
    //     #40c6f1 100%),
    //   linear-gradient(#42c6f1, #42c6f1);
    // background-blend-mode: normal, normal;
    // background-color: var(--theme-color-customized-1);
    color: var(--theme-color-customized-1);
  }

  .top {
    width: 100%;
    height: 40px;
    display: flex;

    img {
      width: 40px;
      height: 40px;
      margin-left: 15px;
    }

    .name {
      height: 40px;
      line-height: 40px;
    }
  }

  .title {
    width: 100%;
    height: 40px;
    background-color: #edfbff;

    .button {
      height: 40px;
      display: flex;

      div {
        width: 140px;
        height: 40px;
        text-align: center;
        white-space: nowrap;
        line-height: 40px;
        cursor: pointer;
        background-color: #f0ffff;
      }
    }
  }

  .contents {
    width: 100%;
    height: calc(100% - 80px);

    .opendetail {
      width: 98%;
      height: 100%;
      margin: 0 auto;
      display: flex;

      .open_left {
        width: 40%;
        height: 100%;
        max-width: 500px;
        min-width: 300px;
        overflow-y: auto;
        //background-color: orange;
        max-height: calc(100vh - 64px - 24px - 80px);
        border-right: 12px solid #edfbff;

        .information {
          .b_border {
            width: 90%;
            padding: 2px;
            margin: 5px auto;
            border-bottom: 1px solid #e2e5ea;
            height: 25px;
            display: flex;

            .text {
              width: 160px;
              height: 100%;
              line-height: 25px;
              text-align: right;
              white-space: nowrap;
            }

            .content {
              width: calc(100% - 160px);
              padding-left: 20px;
              display: flex;
              align-items: center;

              .slider {
                width: 40%;
              }

              .input {
                width: 80px;
              }
            }
          }
        }
      }

      .open_right {
        width: 55%;
        height: 100%;
        max-height: calc(100vh - 64px - 30px - 80px);
        margin: 5px auto;
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .open_img {
          width: 40vw;
          height: 22.5vw;
          min-width: 400px;
          min-height: 225px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;

          .img_top {
            margin: 0 auto;
            width: 40vw;
            height: 22.5vw;
            min-width: 400px;
            min-height: 225px;
            background-color: black;
          }

          .img_bottom {
            margin: 0 auto;
            width: 40vw;
            min-width: 400px;
            margin-top: 3px;
            display: flex;
            justify-content: space-between;
          }
        }

        .open_control {
          width: 100%;
          margin: 25px auto;
          display: flex;
          flex-direction: column;

          .button {
            margin: 10px auto;
            display: flex;
            align-items: center;
            background-color: white;
            width: 250px;
            justify-content: space-between;
          }

          .light {
            display: flex;
            align-items: center;
            margin-top: 10px;
            margin: 10px auto;
            width: 500px;

            .text {
              width: 100px;
              padding-right: 10px;
            }

            .content {
              display: flex;
              width: calc(100% - 100px);

              .slider {
                width: 90%;
              }

              .input {
                width: 100px;
              }
            }
          }
        }
      }
    }
  }
}

.time-zone {
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.update-version {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 400px;

  .upload-demo {
    display: flex;
    align-items: center;

    /deep/ .el-upload-list {
      height: 34px;
      margin-left: 40px;
      display: flex;
      align-items: center;
    }
  }

  .up-header {
    display: flex;
    align-items: center;
    height: 40px;
  }

  .header1 {
    display: flex;
    align-items: center;
    height: 40px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;

    .el-upload__tip {
      margin-left: 50px;
    }
  }

  .up-content {
    height: 330px;
    border-top: 1px solid #d7ecf3;
    width: 100%;
    display: flex;

    flex-direction: column;

    .table-head {
      height: 40px;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      color: var(--theme-color-customized-1);
      border-bottom: 1px solid #d7ecf3;

      div {
        width: 180px;
      }
    }

    .table-body {
      height: 290px;
      overflow: auto;
    }
  }

  .upcontentlocal {
    height: 290px;
  }

  .up-footer {
    height: 40px;
  }
}

.remote-addr {
  height: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .newaddr {
    display: flex;
    align-items: center;
    width: 100%;

    .label {
      width: 90px;
      text-align: right;
      padding-right: 5px;
    }

    .inputs {
      width: 230px;
    }

    .tips {
      position: absolute;
      right: 0;
      bottom: 0;
      transform: translate(-90px, 18px);
    }
  }
}

.mask-overall {
  position: fixed;
  top: -64px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  height: 100%;
  // background-color: rgba(0, 0, 0, 0.65);
  background-color: rgba(0, 0, 0, 0.65);
  height: calc(100% + 64px);
  animation: move 0.3s linear;
  animation-fill-mode: forwards;

  @keyframes move {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .mask-main {
    position: absolute;
    right: 40px;
    top: 40px;
    font-size: 40px;
    z-index: 99;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }

  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    height: 80%;
  }
}
</style>
